// Four Bees Consultancy — site content constants.
// Edit here to update copy / contact info; redeploy after changes.

export const SITE = {
  name: "Fourbees Consultancy",
  shortName: "Fourbees",
  tagline: "Real Industry Experience. Practical Business Solutions.",
  location: "Essex, United Kingdom",
  // TODO (editable): verify these contact details — placeholder until confirmed.
  email: "simon@fourbeesconsultancy.co.uk",
  phone: "07842 532224",
  linkedin: "https://www.linkedin.com/in/simon-sammut-a66b87281",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_31ed5bc6-f99f-4729-88e4-3b6ae0ebb739/artifacts/aab4u5qa_give%20this%20a%20white%20ba.png",
  founderPhoto:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_ff3c1b3a-42c9-479d-bdd9-90b7771dd0c6/artifacts/07f4ef11565efd52_20260911_133814306_iOS.jpg",
  founderName: "Simon",
  companyNo: null, // placeholder — confirm before publishing
  domain: "fourbeesconsultancy.co.uk",
};

export const NAV = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/services", label: "Services" },
  { href: "/dairy-growth", label: "Dairy Growth" },
  { href: "/approach", label: "Our Approach" },
  { href: "/contact", label: "Contact" },
];
